﻿import $ from "jquery";
import Hover from "./Hover";
import Lightbox from "./Lightbox";

const logEventAttr = "data-logo-log-event",
	iconSelector = "img[data-logo-icon=true]",
	hoverIdAttr = "data-logo-hover-id",
	embeddingTypeAttr = "data-logo-embedding-type",
	showLoadingIndicatorAttr = "data-logo-show-loading-indicator",
	displayModeAttr = "data-logo-display-mode";

export default class Service {
	constructor(settings, $ep) {
		this.icons = $ep.find(iconSelector);

		this.settings = settings;

		this.create();
		this.initEventsListener();
	}

	create() {
		this.icons
			.each((index, logoIcon) => {
				const $logoIcon = $(logoIcon);

				const logoId = $logoIcon.attr("id");
				const popupId = $logoIcon.attr(hoverIdAttr);

				const logo = {
					logoId: logoId,
					popupId: popupId,
					refs: {
						$icon: $logoIcon,
						$popup: $(`#${popupId}`)
					},
					hasIframe: $logoIcon.attr(embeddingTypeAttr) === "iframe",
					hoverDirection: this.settings.hoverDirection,
					showLoadingIndicator: $logoIcon.attr(showLoadingIndicatorAttr) === "true",
					logEvent: $logoIcon.attr(logEventAttr)
				};

				const Instance = this.getInstance($logoIcon);

				$logoIcon.data("ccsLogo", new Instance(logo, this.settings));
			});
	}

	getInstance($icon) {
		const displayMode = $icon.attr(displayModeAttr).toLowerCase();

		return displayMode === "hover"
			? Hover
			: Lightbox;
	}

	initEventsListener() {
		this.icons
			.on("ccsLogoOpen",
				(event) => {
					if (this.openedLogo) {
						event.preventDefault();
						return false;
					}

					const instance = $(event.currentTarget).data("ccsLogo");

					this.openedLogo = instance;
				})
			.on("ccsLogoClose", () => this.openedLogo = null);

		$(window).on("resize orientationchange",
			() => {
				if (this.openedLogo) {
					this.openedLogo.resize();
				}
			}
		);
	}
}